module.exports = __webpack_public_path__ + "img/consultoria_9-16_810.f6864313.jpg";